var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row animated fadeIn"},[_c('Loading',{attrs:{"active":true,"is-full-page":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }